export const FEATURE_FLAGS_HTTP_HEADER_NAME = 'mvt-assignment';

export const FLAG_DELIMITER = '-';
export const NAME_VALUE_DELIMITER = ':';
